<ion-list>
    <div>
        <!-- <ion-item-divider class="list-header" color="light">
            <img class="list-header-img" src='../../../assets/imgs/sport_types/{{ eventType }}.png'>
            <div class="primary">{{ eventArea }}</div>
        </ion-item-divider> -->
        <ion-item class="list-item button-flex" *ngFor="let event of events" (click)="onEventLoad(event)">
            <ion-avatar item-start>
                <img src="{{event.imgPath}}">
            </ion-avatar>
            <ion-row *ngIf="type === 'Events'" class="flex-space-between">
                <h4 class="event-date">{{ event.dateFormatted }}</h4>
                <h4 class="event-date" *ngIf="event.eventType.includes('V')">{{ event.distance }}</h4>
                <h4 class="event-date" *ngIf="event.eventStatus.includes('C')" style="margin-left: -80px;">
                    {{ event.distance }}</h4>
                <h4 style="color:red" *ngIf="event.eventStatus.includes('C')">{{ getEventStatus(event) }}</h4>
            </ion-row>

            <ion-row *ngIf="type === 'Events'">
                <h4 text-nowrap>{{ event.eventName }}</h4>
            </ion-row>

            <ion-row *ngIf="type !== 'Events'">
                <h4 class="event-date">{{ event.dateFormatted }}</h4>
                <h4 class="padding-left" style="max-width: 75%;" text-nowrap>
                    {{ event.eventName }}</h4>
            </ion-row>
        </ion-item>
    </div>
</ion-list>

<ion-infinite-scroll (ionInfinite)="loadNextPage($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
    </ion-infinite-scroll-content>
</ion-infinite-scroll>